import React, { memo } from 'react';

import { TSelectOption } from '@interfaces/components/componentTypes';
import { IAddItemToExistingAssetRentRequestDTO } from '@interfaces/rent/dto/assetRentDTO';

import AddNewAssetToRequest from '../AddNewAssetToRequest';

export interface IProposeNewDatesParams {
	itemId: string;
	endDate: number;
	startDate: number;
	comment?: string;
}

export type TProposeNewDatesForItemParams = (params: IProposeNewDatesParams) => void;

interface IProposeNewDatesForItemParams {
	proposeNewDatesForAsset: TProposeNewDatesForItemParams;
	closeModal: () => void;
	selectedAssetId?: TSelectOption;
	setIsDisableClickOutside?: (isDisableClickOutside: boolean) => void;
	requestId: string;
}

export const confirmBtnText = 'Save';

function ProposeNewDatesForItem({
	proposeNewDatesForAsset,
	closeModal,
	selectedAssetId,
	requestId,
}: IProposeNewDatesForItemParams) {

	const handleProposeDates = ({
		assetDbId,
		startDate,
		endDate,
		comment,
	}: IAddItemToExistingAssetRentRequestDTO) => {
		proposeNewDatesForAsset({
			itemId: assetDbId,
			startDate,
			endDate,
			comment,
		});
	};

	return (
		<AddNewAssetToRequest
			addNewAssetToRequest={handleProposeDates}
			closeModal={closeModal}
			confirmBtnText={confirmBtnText}
			requestDbId={requestId}
			selectedAssetId={selectedAssetId}
		/>
	);
}

export default memo(ProposeNewDatesForItem);
